import { format } from 'date-fns';

export function formatDateToIso8601(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function truncateText(text: string, maxLength = 40): string {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
}

export function formatDateToHumanReadable(date: string): string {
  if (!date) return '';

  return format(new Date(date), 'MMM d, yyyy h:mm a');
}

export function getWeekStartDate(date: Date): string {
  const d = new Date(date);
  const day = d.getUTCDay();
  d.setUTCDate(d.getUTCDate() - day);
  return formatDateToIso8601(d);
}

export function getMonthStartDate(date: Date): string {
  const d = new Date(date);
  const monthStart = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1));
  return formatDateToIso8601(monthStart);
}
